import React from 'react';
import Link from '../link';

interface FloatingActionLinkProps {
  title: string;
  to: string;
  onBeforeNavigate?: () => void;
  icon?: string;
}

const FloatingActionLink = ({ title, to, onBeforeNavigate, icon }: FloatingActionLinkProps) => (
  <section className="page-section page-section-sticky-bottom text-center">
    <Link data-wx-button="action" to={to} onClick={onBeforeNavigate}>
      <div className="button-text">{title}</div>
      {icon && (
        <div className="button-icon">
          <i className={`no-margin ${icon}`} />
        </div>
      )}
    </Link>
  </section>
);

export default FloatingActionLink;
